import { defineComponent as _defineComponent } from 'vue'
import { reactive, watch } from 'vue';
  import { Button } from '@/ui/components/Button';
  import { Modal } from '@/ui/components/Modal';
  import { Course, CourseForm } from '@/entities/trainings';
  import { CREATE_COURSE_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';
  import { InputField } from '@/ui/components/form/InputField';
  import { ValidationError } from '@/entities/validation';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CreateCourseModal',
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    course: {
      type: Object as () => Course,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: {
    close: () => true,
    success: (courseForm: CourseForm) => true,
  },
  setup(__props, { emit }) {

const props = __props;

  

  

  const form = reactive({
    title: '',
    description: '',
  });

  const validationErrors = reactive({
    title: [] as ValidationError[],
  });

  const validateForm = () => {
    validationErrors.title = [];

    if (!form.title.trim()) {
      validationErrors.title = [{ field: 'title', type: 'required', parameters: [] }];
      return false;
    }

    return true;
  };

  watch(() => props.active, newVal => {
    if (newVal) {
      resetForm();
    }
  });

  const resetForm = () => {
    form.title = props.course?.title ?? '';
    form.description = props.course?.description ?? '';
    validationErrors.title = [];
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    const courseForm: CourseForm = {
      title: form.title.trim(),
      description: form.description.trim() || null,
    };

    emit('success', courseForm);
  };

return { __sfc: true,props, emit, form, validationErrors, validateForm, resetForm, handleSubmit, Button, Modal, CREATE_COURSE_MODAL_WIDTH, PageSubtitle, InputField }
}

})